export default {
  namespaced: true,
  state: {
    modalState: false,
    modalName: "",
    props: null,
    modalHistoryRouting: [],
  },
  getters: {
    getModalState: (state) => state.modalState,
    getModalName: (state) => state.modalName,
    getModalProps: (state) => state.props,
    getModalHistoryRouting: (state) => state.modalHistoryRouting,
  },
  mutations: {
    SET_MODAL(state, modal) {
      state.modalState = modal.state;
      state.modalName = modal.name ? modal.name : "";
      state.props = modal.props;
      state.modalHistoryRouting.push(modal);
    },
  },
  actions: {},
};
